import React from 'react';

interface GooglePayButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: (...args: Array<any>) => any;
}

export default function GooglePayButton({ onClick, ...restButtonProps }: GooglePayButtonProps) {
  return (
    <React.Fragment>
      <button
        onClick={onClick}
        className="pointer-events-auto h-10 min-h-[3rem] min-w-full rounded border-0 bg-black bg-contain bg-center bg-no-repeat bg-origin-content px-6 py-3 shadow-none"
        style={{ backgroundImage: `url('https://www.gstatic.com/instantbuy/svg/dark_gpay.svg')` }}
        {...restButtonProps}
      />
    </React.Fragment>
  );
}
